import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';

const PageContext = createContext();


function PageProvider(props) {
  const [viewport, setViewport] = useState('xl');
  const [language, setLanguage] = useState(props.defaultLanguage);
  const [showData, setShowData] = useState(false);

  return (
    <PageContext.Provider value={{
      viewport,
      setViewport,
      language,
      languages: props.languages,
      setLanguage,
      showData, setShowData
    }} {...props} />
  );
}

function usePage() {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error('usePage must be used within a PageProvider');
  }
  const {
    viewport,
    setViewport,
    language,
    languages,
    setLanguage,
    showData, setShowData
  } = context;

  return {
    viewport,
    setViewport,
    language,
    languages,
    setLanguage,
    showData, setShowData
  };
}

PageProvider.propTypes = {
  languages: PropTypes.array,
  defaultLanguage: PropTypes.string,
};
PageProvider.defaultProps = {
  languages: ['es', 'en'],
  defaultLanguage: 'es'
};


export {PageProvider, usePage};
